var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaultReportCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#8CD280"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83329 10.8333C6.66329 10.8333 6.49329 10.7667 6.36329 10.6367L4.52996 8.80334C4.26996 8.54334 4.26996 8.12001 4.52996 7.86001C4.78996 7.60001 5.21329 7.60001 5.47329 7.86001L6.83663 9.22334L10.53 5.53001C10.79 5.27001 11.2133 5.27001 11.4733 5.53001C11.7333 5.79001 11.7333 6.21334 11.4733 6.47334L7.30663 10.64C7.17663 10.77 7.00663 10.8367 6.83663 10.8367L6.83329 10.8333Z",
    fill: "#0F0F0F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaultReportCompleted);
export default __webpack_public_path__ + "static/media/fault-report-completed.69dae6d3.svg";
export { ForwardRef as ReactComponent };